import React from 'react'
import imageLogoAbt from "../../../../images/logo-abt.png";

const Footer  = () => {
    return (
        <footer>
            <div className="box">
                <div className="motto">
                    <img src={imageLogoAbt} alt="ABT"/>
                        <p>Our vision is a <strong>world where people understand each other</strong></p>
                </div>
                <br className="cl"/>
                    <p>
                        © MOOVEEZ Company, 2018
                    </p>
            </div>
        </footer>
    );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/company/footer/view/Footer.jsx